import React, { memo, useMemo } from 'react';
import { Stack, Typography, Button, Icon } from 'investira.react.components';
import { Upload, BulkContextActions } from '../../components/organisms';
import { ArquivosTemplate } from '../../components/templates';
import { useUploadContext } from '../../contexts/UploadContext';
import withArquivos from '../../hoc/withArquivos';
import columns from './columns';

const Arquivos = memo(props => {
  const uploadContext = useUploadContext();
  const xColumns = useMemo(() => columns, []);

  const handleUploadClick = () => {
    uploadContext.actions.open();
  };

  return (
    <ArquivosTemplate
      title="Uploads"
      description="Você pode enviar arquivos XML conforme os padrões ANBIMA 4 e 5."
      headerRenderActions={
        <Button
          disabled={props.disabled}
          variant="contained"
          color="primary"
          startIcon={<Icon color="secondary" iconName="upload" size={16} />}
          size="small"
          sx={{ px: 2 }}
          onClick={handleUploadClick}>
          Selecionar arquivos
        </Button>
      }
      contentWrapper={content => <Upload onFinish={props.handleFinishUpload}>{content}</Upload>}
      dataGridProps={{
        columns: xColumns,
        data: props.arquivos,
        includes: props.includes,
        readData: props.readArquivos,
        isLoading: props.isLoading,
        initialState: {
          pagination: props.pagination,
          sorting: props.sorting,
          columnFilters: props.columnFilters
        },
        manualFiltering: true,
        manualPagination: true,
        manualSorting: true,
        getRowId: row => row._rid,
        state: {
          isLoading: props.isLoading,
          pagination: props.pagination,
          sorting: props.sorting,
          columnFilters: props.columnFilters,
          showProgressBars: props.isRefetching,
          rowSelection: props.rowSelection
        },
        rowCount: props.rowCount,
        onColumnFiltersChange: props.setColumnFilters,
        onPaginationChange: props.setPagination,
        onRowSelectionChange: props.setRowSelection,
        renderTopToolbarCustomActions: ({ table }) => {
          const selectedRows = table.getSelectedRowModel().rows;
          const isSomeRowSelected = selectedRows.length > 0;

          return (
            <BulkContextActions
              onDeleteClick={() => {
                props.bulkDeleteArquivos(selectedRows);
              }}
              disabled={props.isLoading || props.isRefetching || !isSomeRowSelected}
            />
          );
        },
        renderEmptyRowsFallback: () => {
          return (
            <Stack py={6}>
              <Typography variant="body1" color="textPrimary" align="center">
                Arraste e solte alguns arquivos aqui
              </Typography>
              <Typography component="p" variant="caption" color="textPrimary" align="center">
                (Somente serão aceitos arquivos .xml)
              </Typography>
            </Stack>
          );
        }
      }}
    />
  );
});

Arquivos.displayName = 'Arquivos';

export default withArquivos(Arquivos);
